import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollTop}
      data-testid="back-to-top"
      aria-label="Voltar ao topo"
      className={`fixed bottom-6 left-6 z-40 h-11 w-11 inline-flex items-center justify-center rounded-full bg-white border border-stone-200 text-[#103C4A] shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${
        visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none translate-y-2"
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
